module.exports = ".botao-salvar {\n    margin-left: 37%;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/modal/resumo-novo-fta-modal/resumo-fta-modal.component.css
// module id = ./src/app/modal/resumo-novo-fta-modal/resumo-fta-modal.component.css
// module chunks = main